import { render, staticRenderFns } from "./userRoleView.vue?vue&type=template&id=312da636&scoped=true&"
import script from "./userRoleView.vue?vue&type=script&lang=js&"
export * from "./userRoleView.vue?vue&type=script&lang=js&"
import style0 from "./userRoleView.vue?vue&type=style&index=0&id=312da636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312da636",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('312da636')) {
      api.createRecord('312da636', component.options)
    } else {
      api.reload('312da636', component.options)
    }
    module.hot.accept("./userRoleView.vue?vue&type=template&id=312da636&scoped=true&", function () {
      api.rerender('312da636', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/userRoleView.vue"
export default component.exports